import { useMemo } from "react";
import CSS from "./static/css/BlurEmptyBlock.module.css";

const BlurEmptyBlock = (
    {
        location,
        class_name_list,
    }:{
        location: "top" | "bottom";
        class_name_list?: string[];
    }
) => {
    const mainClassName = useMemo(() => {
        const RTN = [];

        RTN.push("g_backdrop_filter");

        if(class_name_list){
            RTN.push(...class_name_list);
        }

        RTN.push(CSS.l_BlurEmptyBlock_main);
        RTN.push(CSS.location);
        RTN.push(CSS[location]);


        return RTN.join(" ");
    }, [class_name_list, location])

    return (
        <div className={mainClassName} />
    )
}

export default BlurEmptyBlock;